{
  "addButtonLabel": "प्रक्रिया या शल्यचिकित्सा",
  "date": "तारीख",
  "datePlaceholder": "e.g. June 2022, 2021, or ~5 years ago",
  "location": "स्थान",
  "locationPlaceholder": "e.g. Ormiston Hospital, Auckland",
  "nextLabel": "$t(common:next): <b>गतिशीलता</b>",
  "procedure": "प्रक्रिया या सर्जरी का विवरण",
  "procedurePlaceholder": "कृपया अंग्रेज़ी में भरें। उदाहरण के लिए: <br/>\nColonoscopy to investigate bleeding",
  "saveButton": "प्रक्रिया या सर्जरी सहेजें",
  "text": "<p>हमारे पास {{company}} में आपकी पिछली एंडोस्कोपी का रिकॉर्ड है:</p>\n<ul><li><strong>{{procedure}}</strong> – <strong>{{date}}</strong> को</li></ul>\n<p>क्या तब से आपकी कोई और एंडोस्कोपी, पेट से जुड़ी या बड़ी सर्जरी हुई है?</p>",
  "textNoProcedure": "क्या आपने पहले कभी एंडोस्कोपी, पेट की सर्जरी या कोई बड़ी सर्जरी करवाई है?",
  "title": "हाल की प्रक्रियाएं या सर्जरी"
}
